import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { CryptoService } from '../crypto.service';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { MorseComponent } from '../morse/morse.component';

@Component({
  selector: 'app-learn-by-heart',
  templateUrl: './learn-by-heart.component.html',
  styleUrls: ['./learn-by-heart.component.css']
})
export class LearnByHeartComponent extends GeneralExerciseComponent {

  
  @ViewChild('morse',{static: true})
  private view: MorseComponent;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected cryptoService: CryptoService) {
    super(activatedRoute, topicService, messageService);
  }

  hints: string[];
  errors: number[] = [];

  setTypeSpecificsFromConfiguration() {
   this.hints = this.configuration.typespecifics.hints;
   let temphints = this.configuration.typespecifics.hints;
   this.hints = [];
   for (let hint of temphints) {
     this.hints[hint.charCodeAt(0) - 65] = this.cryptoService.encodeMorse(hint);
   }
   this.view.setHints(this.hints);
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.mapping) {
        this.view.setmapping(this.state.typespecific.mapping);
      }
    }
  }
  computeState() {
    this.state.typespecific.mapping = this.view.getMapping();
  }

  checkSolution() {
    let solution = this.view.getMapping();
    this.errors = solution.split(",").map((v,i) => [(v != this.cryptoService.encodeMorse(String.fromCharCode(i+65).toLowerCase())),i] ).filter(v => v[0]).map(v => +v[1]);
    
    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("notCorrectlyFilled"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correctlyFilled"), "success", 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    }
  }

  evaluate(): number[] {
    let solution = this.view.getMapping();
    let errors = solution.split(",").map((v,i) => [(v != this.cryptoService.encodeMorse(String.fromCharCode(i+65).toLowerCase())),i] ).filter(v => v[0]).map(v => +v[1]);
    let result = [(26-this.hints.filter(v => v!=undefined && v!="").length - errors.length) / 5, (26-this.hints.filter(v => v!=undefined && v!="").length) / 5];
    
    return result;
  }


}
